import { createSelector } from '@ngrx/store';
import { selectPaymentDate, selectPaymentDetails } from '../reducers';
import { UpdateSessionRedirectStateV1Request } from '@arc/unified-payments-frontend/shared-payment';
import {
  selectRedirectOneTimePaymentAccounts,
  selectSessionId,
  SessionStore,
  selectVirtualOtherwisePrimaryTenantId,
} from '@arc/unified-payments-frontend/shared-stores';
import { selectCurrentLanguage } from '@arc/unified-payments-frontend/i18n';
import {
  selectPaymentAccountBurn,
  selectPaymentReferenceNumber,
} from './pay-on-account.selectors';
import { selectPadAgreementRemittanceFile } from './pad-agreement.selectors';

export const selectUpdateSessionRedirectStateRequest = createSelector(
  selectVirtualOtherwisePrimaryTenantId,
  selectSessionId,
  selectPaymentReferenceNumber,
  selectPaymentAccountBurn,
  selectPaymentDate,
  selectPaymentDetails,
  selectRedirectOneTimePaymentAccounts,
  SessionStore,
  selectPadAgreementRemittanceFile,
  selectCurrentLanguage,
  (
    tenantId,
    sessionId,
    paymentReference,
    selectedPaymentAccountBurn,
    paymentDate,
    paymentDetails,
    oneTimePaymentAccounts,
    sessionSummary,
    padAgreementRemittanceFile,
    currentLanguage,
  ) => {
    const payload: UpdateSessionRedirectStateV1Request = {
      redirectState: {
        paymentReference,
        paymentDetails: {
          paymentDate: paymentDetails.paymentDate,
          receiptRecipients: paymentDetails.receiptRecipients,
          buyerAccount: paymentDetails.buyerAccount,
          amount: paymentDetails.amount,
          paymentNotes: paymentDetails.paymentNotes,
          referenceDate: paymentDetails.referenceDate,
          referenceNumber: paymentDetails.referenceNumber,
        },
        paymentDate,
        selectedPaymentAccountBurn,
        oneTimePaymentAccounts,
        sessionSummary,
        currentLanguage,
      },
    };

    if (padAgreementRemittanceFile) {
      payload.redirectState.paymentDetails.remittanceFileAttachmentData =
        padAgreementRemittanceFile;
    }

    return {
      tenantId,
      sessionId,
      payload,
    };
  },
);
